import HelloRemoteReactComp from './HelloRemoteReactComp';

const toExport = {
  HelloRemoteReactComp,
}

export default toExport;
